import { render } from "./custom-radio-group.vue?vue&type=template&id=74b6a2a4"
import script from "./custom-radio-group.vue?vue&type=script&lang=js"
export * from "./custom-radio-group.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__